export { default as LineChart } from "./lineChart.vue"
export { default as PieChart } from "./pieChart.vue"
export { default as MapChart } from "./mapChina.vue"
export { default as BarChart } from "./barChart.vue"
export { default as QuadChart } from "./quadrantsChart.vue"



// WEBPACK FOOTER //
// ./src/component/charts/index.js